import CoconeuseBioTemplate from "../components/coconeuses/CoconeuseBioTemplate";

const CoconeuseAmeDiva = () => (
  <CoconeuseBioTemplate
    name="Âme Diva"
    subtitle="La voix comme médecine · Le chant comme passage"
    mainPhoto="https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/2d7ag7eo_DSC00736.jpg"
    bioText={[
      "Âme Diva nous guide dans l'art de libérer la voix.",
      "À travers la technique vocale, le chant intuitif et le chant canalisé, elle ouvre un espace où la voix devient un soin.",
      "Un espace de transformation vibratoire où l'âme peut se dire, se déposer et se révéler.",
      "Car lorsque la voix s'ouvre, quelque chose de profondément vivant se remet à circuler.",
    ]}
    galleryPhotos={[
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/2dky9e18_DSC01736.jpg",
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/w5qk4tnk_DSC03886.jpg",
      "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/3gd84nwk_DSC03112%20%281%29.jpg",
    ]}
    expertise={["Libération de la voix", "Chant intuitif", "Expression de l'âme"]}
  />
);

export default CoconeuseAmeDiva;
